<template>
  <div class="container-fluid">
    <div class="row white alarm-settings-general z-depth-3 shunt-page-spacing">
      <div class="col s4">
        <alarmsettings-form
            :setting.sync="alarmSettings"
            :save="save"
            :reset="reset"
            @update-trigger="updateTrigger" />
      </div>
      <div class="col s8">
        <shunt-chart v-model="alarmSettings"
            :sectionData="sectionData"
            @update-trigger="updateTrigger" />
      </div>
    </div>
  </div>
</template>

<script>
import SettingsForm from './_settingsForm'
import ShuntChart from './_shuntChart'
import SectionAlarmService from '@/services/r8/SectionAlarmService'
import moment from 'moment'

export default {
  components: {
    'alarmsettingsForm': SettingsForm,
    'shuntChart': ShuntChart
  },
  props: ['sectionData'],
  name: 'AlarmSettings',
  data () {
    return {
      isSaving: false,
      alarmSettings: { }
    }
  },
  async created () {
    this.alarmSettings = this.defaultAlarmSettings()
    await this.load()
  },
  mounted () {
    this.alarmSettings.objectId = this.uniqueIdR8
  },
  methods: {
    updateTrigger (prop, val) {
      if (this.alarmSettings[prop] === undefined) { return }
      this.alarmSettings[prop] = val
      this.alarmSettings = { ...this.alarmSettings }
    },
    reset () {
      this.alarmSettings = { ...this.prevSettings }
    },
    async load () {
      try {
        const resp = await SectionAlarmService.getAlarmSettings(this.token, this.uniqueIdR8)
        if (!resp) {
          this.prevSettings = this.defaultAlarmSettings()
          Object.freeze(this.prevSettings)
          return
        }
        this.alarmSettings = resp
        this.prevSettings = { ...resp } // clone
        Object.freeze(this.prevSettings)
      } finally { }
    },
    async save  () {
      if (this.alarmSettings.id) {
        await SectionAlarmService.updateAlarmSettings(this.token, this.uniqueIdR8, this.alarmSettings)
      } else {
        const resp = await SectionAlarmService.saveAlarmSettings(this.token, this.uniqueIdR8, this.alarmSettings)
        this.alarmSettings = resp
      }
    },
    defaultAlarmSettings () {
      return {
        objectId: this.uniqueIdR8,
        createdDateTime: moment.utc(),
        warningThreshold: 0,
        alarmThreshold: 0,
        shuntThreshold: 0,
        shuntCurrentActive: true,
        minShuntTimeActive: true,
        maxShuntTimeActive: true,
        minShuntTime: 0,
        maxShuntTime: 0
      }
    }
  },
  computed: {
    token () {
      return this.$parent.token
    },
    uniqueIdR8 () {
      return this.$parent.uniqueIdR8
    }
  },
  watch: {
    uniqueIdR8 () {
      this.alarmSettings = this.defaultAlarmSettings()
      this.alarmSettings.objectId = this.uniqueIdR8
      this.load()
    }
  }
}
</script>

<style scoped>
  .shunt-page-spacing {
    margin-right: 11.25px;
    margin-left: 11.25px;
    margin-top: 21.25px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/axleshunt/AlarmSettings/Index.vue